import React from "react";
import { Check } from "lucide-react";
import { about } from "../mock";

const About = () => {
  return (
    <section id="sobre" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal relative order-2 lg:order-1">
          <img
            src={about.image}
            alt="Estrutura da clínica Foco Vision"
            className="rounded-[2rem] shadow-xl w-full h-[440px] md:h-[520px] object-cover"
          />
          <div className="absolute -top-6 -right-6 hidden md:block bg-[#2f3a45] text-white rounded-2xl px-7 py-5 shadow-xl">
            <div className="font-display font-bold text-3xl">+15</div>
            <div className="text-sm text-[#94a7b8]">anos cuidando da sua visão</div>
          </div>
        </div>

        <div className="reveal order-1 lg:order-2">
          <span className="text-xs font-semibold tracking-widest uppercase text-[#b89a5a]">
            {about.eyebrow}
          </span>
          <div className="gold-line mt-3" />
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#2f3a45] mt-5">
            {about.title}
          </h2>
          {about.paragraphs.map((p, i) => (
            <p key={i} className="text-[#4a5a68] mt-4 leading-relaxed">
              {p}
            </p>
          ))}

          <ul className="mt-7 space-y-3">
            {about.bullets.map((b) => (
              <li key={b} className="flex items-center gap-3">
                <span className="w-6 h-6 rounded-full bg-[#b89a5a]/15 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-[#b89a5a]" />
                </span>
                <span className="text-[#2f3a45] font-medium">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
